module.exports = "/_next/static/images/macpunks-story-4-d4c05ce851be04cefb8ae9b5ce20fe89.png";